function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.4;}\n\t.st1{clip-path:url(#XMLID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:#FBC5A8;}\n\t.st2{clip-path:url(#XMLID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:#F6ACC2;}\n\t.st3{clip-path:url(#XMLID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:#E99AC2;}\n\t.st4{clip-path:url(#XMLID_3_);fill-rule:evenodd;clip-rule:evenodd;fill:#75CCDA;}\n\t.st5{opacity:0.6;}\n\t.st6{clip-path:url(#XMLID_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#FBC5A8;}\n\t.st7{clip-path:url(#XMLID_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#F6ACC2;}\n\t.st8{clip-path:url(#XMLID_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#E99AC2;}\n\t.st9{clip-path:url(#XMLID_6_);fill-rule:evenodd;clip-rule:evenodd;fill:#75CCDA;}\n\t.st10{opacity:0.8;}\n\t.st11{clip-path:url(#XMLID_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#FBC5A8;}\n\t.st12{clip-path:url(#XMLID_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#F6ACC2;}\n\t.st13{clip-path:url(#XMLID_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#E99AC2;}\n\t.st14{clip-path:url(#XMLID_8_);fill-rule:evenodd;clip-rule:evenodd;fill:#75CCDA;}\n\t.st15{clip-path:url(#XMLID_9_);fill-rule:evenodd;clip-rule:evenodd;fill:#FBC5A8;}\n\t.st16{clip-path:url(#XMLID_9_);fill-rule:evenodd;clip-rule:evenodd;fill:#F6ACC2;}\n\t.st17{clip-path:url(#XMLID_9_);fill-rule:evenodd;clip-rule:evenodd;fill:#E99AC2;}\n\t.st18{clip-path:url(#XMLID_9_);fill-rule:evenodd;clip-rule:evenodd;fill:#75CCDA;}\n");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_4_",
  className: "st0",
  cx: 483.7,
  cy: 483.7,
  r: 483.7
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M-2.4,184.3C78.4,86.9,164.7,41.2,189.1,28.9c80.3-40.4,149-51.3,192.8-57.8C527.7-50.7,636.6-21.5,713.2,0 c113.9,31.9,141.4,63.8,154.2,86.7c19.9,35.8,6.4,54.4,30.1,83.1c38.5,46.6,92.4,19.9,145.5,67.5c35.3,31.8,45.3,73.7,48.2,87.9 c15,75.2-20,139.6-31.3,159c-116.5,200.1-506,280-834.9,204.8c-2.5-0.6-6-1.4-10.5-2.4C145.9,670.5-94,612.7-134,477.1 C-163.2,378.2-75.7,272.7-2.4,184.3z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M-175.9,327.7c8.4-8.3,39.3,34.4,92.8,38.6c32.4,2.5,50.3-10.9,138.5-59c110.3-60.1,122.1-60.8,131.3-60.2 c65.5,4,73.1,73,142.2,83.1c59.2,8.7,68.6-39.8,155.4-55.4c97.5-17.5,124,36.8,203.6,10.8c68-22.2,66-67.6,127.7-75.9 c48.2-6.5,59.6,19.9,145.8,37.3c73.3,14.9,83.5-0.5,143.4,10.8c68,12.9,175.5,55.6,180.7,107.2c9,88.9-287.2,183.8-305.5,189.5 c-20.4,6.4-35.5,11.1-41,12.7c-194.9,55.5-388.3,110.6-616,101.4C-2.9,655.4-100.5,522.8-100.7,522c-0.1-0.3-0.2-0.7-0.2-0.7 c-0.1-0.7-0.2-1.4-0.7-4.6C-120.2,402.9-187.1,338.7-175.9,327.7z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M-28.2,546.2c7.4-12.9,33.7-54.2,80-64.4c50.7-11.1,64.9,28.4,127.7,30.1c71.5,2,87.7-48,148.2-38.6 c54,8.4,54.8,52.5,104.8,61.4c71.9,12.8,94.5-73.8,186.7-85.5c93-11.9,128.3,68.6,213.2,45.8c54.8-14.8,52.6-51.7,110.8-79.5 c104.9-50.1,263.7-2.4,275.9,57.8c4.3,21-9.1,44.4-188.5,187.2c-109.5,87.2-163.4,132.9-179.5,138.5 c-36.7,12.7-65.6,18.1-82.9,20.6c-396.8,57.9-421.5,76.3-512.9,57.2c-37-7.7-235.3-49.1-286-186.2 C-37.2,673-62.3,606.1-28.2,546.2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M52.4,880.1c56,46.1,42.2,93.6,92.2,130.6c17.1,12.7,45.3,26.8,91.6,27.7c88.4,28.1,162.8,36.8,212,39.8 c46.4,2.8,257.8,11.5,421.6-100c20.5-13.9,67-47.9,93.4-107.7c2.8-6.3,35-79.9,8.4-101.2c-13.6-10.9-28.4-0.8-54.8-0.7 c-74.9,0.3-92.7-80.4-156.6-86.7c-61.3-6.1-74.3,65.2-148.2,66.3c-59.9,0.9-65-50.7-133.7-54.2c-83.1-4.2-102,51.1-187.9,49.4 c-83-1.7-100-54-156.6-34.9c-39.1,13.2-34.9,39.4-111.4,85C-0.5,807-16.8,814-17.5,827.1C-18.4,846,16.6,850.6,52.4,880.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_7_",
  className: "st5",
  cx: 483.4,
  cy: 483.3,
  r: 423.2
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M58.1,221.4c70.7-85.2,146.2-125.2,167.6-136C295.9,50,356,40.5,394.3,34.8c127.5-19.1,222.9,6.5,289.9,25.3 C783.9,88,808,115.9,819.1,136c17.4,31.3,5.6,47.6,26.4,72.7c33.7,40.8,80.9,17.4,127.3,59.1c30.9,27.8,39.7,64.5,42.2,76.9 c13.2,65.8-17.5,122.2-27.4,139.1C885.6,659,544.7,728.9,257,663.1c-2.2-0.5-5.3-1.2-9.2-2.1c-60-14.2-269.9-64.7-304.9-183.4 C-82.6,391.1-6,298.7,58.1,221.4z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M-93.7,346.8c7.3-7.3,34.4,30.1,81.2,33.7c28.3,2.2,44-9.6,121.2-51.7c96.5-52.6,106.8-53.2,114.9-52.7 c57.3,3.5,64,63.9,124.4,72.7c51.8,7.6,60-34.9,136-48.5c85.3-15.3,108.5,32.2,178.1,9.5c59.5-19.4,57.8-59.1,111.7-66.4 c42.2-5.7,52.1,17.4,127.5,32.7c64.2,13,73.1-0.4,125.4,9.5c59.5,11.3,153.5,48.6,158.1,93.8c7.9,77.8-251.3,160.8-267.3,165.8 c-17.8,5.6-31.1,9.7-35.9,11.1c-170.6,48.6-339.8,96.8-539,88.7C57.6,633.6-27.8,517.5-27.9,516.9c-0.1-0.3-0.2-0.6-0.2-0.6 c-0.1-0.6-0.2-1.2-0.6-4C-45,412.7-103.5,356.5-93.7,346.8z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M35.5,538.1c6.4-11.3,29.5-47.5,70-56.3c44.3-9.7,56.8,24.8,111.7,26.4c62.6,1.7,76.8-42,129.7-33.7 c47.2,7.4,47.9,45.9,91.7,53.8c62.9,11.2,82.7-64.5,163.4-74.8c81.4-10.4,112.3,60.1,186.6,40.1c48-12.9,46-45.3,97-69.6 c91.8-43.8,230.7-2.1,241.4,50.6c3.7,18.4-8,38.8-164.9,163.8c-95.8,76.3-143,116.3-157.1,121.2c-32.1,11.1-57.4,15.8-72.5,18 c-347.2,50.6-368.8,66.7-448.8,50c-32.4-6.8-205.9-43-250.3-162.9C27.6,649,5.6,590.5,35.5,538.1z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M106,830.2c49,40.4,36.9,81.9,80.6,114.3c15,11.1,39.6,23.4,80.1,24.2c77.4,24.6,142.4,32.2,185.5,34.8 c40.6,2.4,225.5,10,368.9-87.5c17.9-12.2,58.6-41.9,81.7-94.3c2.4-5.5,30.6-69.9,7.4-88.5c-11.9-9.5-24.8-0.7-48-0.6 c-65.5,0.2-81.1-70.4-137-75.9c-53.6-5.3-65,57-129.7,58c-52.4,0.8-56.9-44.4-117-47.4c-72.7-3.7-89.2,44.7-164.4,43.2 c-72.6-1.5-87.5-47.2-137-30.6c-34.2,11.5-30.6,34.5-97.5,74.4c-20,11.9-34.2,18.1-34.8,29.5C44,800.4,74.7,804.4,106,830.2z"
});

var _ref13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_2_",
  className: "st10",
  cx: 483.8,
  cy: 483.7,
  r: 362.8
}));

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M119.3,259.2c60.6-73.1,125.3-107.3,143.7-116.6c60.2-30.3,111.7-38.5,144.6-43.4 c109.3-16.3,191,5.6,248.5,21.7c85.4,23.9,106.1,47.9,115.7,65.1c14.9,26.8,4.8,40.8,22.6,62.3c28.9,34.9,69.3,14.9,109.1,50.7 c26.5,23.8,34,55.3,36.1,66c11.3,56.4-15,104.7-23.5,119.3c-87.4,150-379.5,210-626.1,153.6c-1.9-0.4-4.5-1-7.9-1.8 c-51.5-12.2-231.4-55.5-261.4-157.2C-1.3,404.6,64.3,325.5,119.3,259.2z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st12",
  d: "M-10.8,366.7c6.3-6.2,29.5,25.8,69.6,28.9c24.3,1.9,37.7-8.2,103.9-44.3c82.7-45.1,91.5-45.6,98.5-45.2 c49.1,3,54.8,54.7,106.6,62.3c44.4,6.5,51.4-29.9,116.6-41.6c73.1-13.1,93,27.6,152.7,8.1c51-16.6,49.5-50.7,95.8-56.9 c36.2-4.9,44.7,14.9,109.3,28c55,11.1,62.6-0.4,107.5,8.1c51,9.7,131.6,41.7,135.5,80.4c6.8,66.7-215.4,137.8-229.1,142.2 c-15.3,4.8-26.6,8.3-30.8,9.5c-146.2,41.6-291.2,82.9-462,76C118.9,612.5,45.7,513,45.6,512.5c-0.1-0.3-0.1-0.5-0.1-0.5 c-0.1-0.5-0.1-1-0.5-3.4C30.9,423.1-19.2,375-10.8,366.7z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M99.9,530.6c5.5-9.7,25.3-40.7,60-48.3c38-8.3,48.7,21.3,95.8,22.6c53.7,1.5,65.8-36,111.1-28.9 c40.5,6.3,41.1,39.4,78.6,46.1c53.9,9.6,70.9-55.3,140-64.1c69.7-8.9,96.3,51.5,159.9,34.3c41.1-11.1,39.5-38.8,83.1-59.6 c78.7-37.6,197.7-1.8,206.9,43.4c3.2,15.7-6.8,33.3-141.3,140.4c-82.1,65.4-122.5,99.7-134.6,103.9c-27.5,9.6-49.2,13.6-62.2,15.5 c-297.6,43.4-316.1,57.2-384.7,42.9c-27.8-5.8-176.5-36.8-214.5-139.7C93.2,625.7,74.3,575.5,99.9,530.6z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M160.4,781c42,34.6,31.6,70.2,69.1,98c12.9,9.5,33.9,20.1,68.7,20.8c66.3,21.1,122.1,27.6,159,29.8 c34.8,2.1,193.3,8.6,316.2-75c15.3-10.4,50.2-35.9,70-80.8c2.1-4.7,26.2-59.9,6.3-75.9c-10.2-8.2-21.3-0.6-41.1-0.5 c-56.2,0.2-69.5-60.3-117.5-65.1c-46-4.5-55.7,48.9-111.1,49.7c-44.9,0.7-48.8-38.1-100.3-40.7c-62.4-3.1-76.5,38.4-140.9,37 c-62.3-1.3-75-40.5-117.5-26.2c-29.3,9.9-26.2,29.6-83.6,63.8c-17.1,10.2-29.3,15.5-29.8,25.3C107.2,755.5,133.5,758.9,160.4,781z "
});

var _ref18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
  id: "XMLID_5_",
  cx: 483.8,
  cy: 483.7,
  r: 302.3
}));

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M180,296.6c50.5-60.9,104.5-89.4,119.7-97.1c50.2-25.3,93.1-32.1,120.5-36.1c91.1-13.6,159.2,4.7,207.1,18.1 c71.2,19.9,88.4,39.9,96.4,54.2c12.4,22.4,4,34,18.8,52c24.1,29.1,57.8,12.4,90.9,42.2c22.1,19.8,28.3,46,30.1,55 c9.4,47-12.5,87.3-19.6,99.4c-72.8,125-316.3,175-521.8,128c-1.5-0.4-3.8-0.9-6.6-1.5c-42.9-10.1-192.8-46.2-217.8-131 C79.5,417.8,134.2,351.8,180,296.6z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M71.6,386.2c5.2-5.2,24.6,21.5,58,24.1c20.2,1.6,31.4-6.8,86.6-36.9c69-37.6,76.3-38,82.1-37.6 c40.9,2.5,45.7,45.6,88.8,52c37,5.4,42.8-24.9,97.1-34.6c60.9-10.9,77.5,23,127.2,6.8c42.5-13.9,41.3-42.2,79.8-47.4 c30.1-4.1,37.2,12.4,91.1,23.3c45.8,9.3,52.2-0.3,89.6,6.8c42.5,8.1,109.7,34.7,112.9,67C990.6,465.1,805.4,524.4,794,528 c-12.7,4-22.2,6.9-25.6,7.9c-121.8,34.7-242.7,69.1-385,63.4c-203.6-8.2-264.6-91.1-264.7-91.6c-0.1-0.2-0.1-0.4-0.1-0.4 c-0.1-0.4-0.1-0.9-0.4-2.9C106.4,433.2,64.6,393.1,71.6,386.2z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M163.9,522.8c4.6-8.1,21.1-33.9,50-40.2c31.7-6.9,40.6,17.7,79.8,18.8c44.7,1.2,54.8-30,92.6-24.1 c33.7,5.3,34.2,32.8,65.5,38.4c44.9,8,59-46.1,116.7-53.5c58.1-7.4,80.2,42.9,133.3,28.6c34.3-9.2,32.9-32.3,69.3-49.7 c65.6-31.3,164.8-1.5,172.4,36.1c2.7,13.1-5.7,27.7-117.8,117c-68.4,54.5-102.1,83.1-112.2,86.6c-22.9,8-41,11.3-51.8,12.9 c-248,36.2-263.4,47.7-320.6,35.7c-23.2-4.8-147.1-30.7-178.8-116.4C158.3,602,142.6,560.2,163.9,522.8z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st18",
  d: "M214.3,731.5c35,28.8,26.4,58.5,57.6,81.6c10.7,7.9,28.3,16.7,57.2,17.3c55.3,17.6,101.7,23,132.5,24.8 c29,1.7,161.1,7.2,263.5-62.5c12.8-8.7,41.9-30,58.3-67.3c1.7-3.9,21.9-49.9,5.3-63.2c-8.5-6.8-17.7-0.5-34.3-0.4 c-46.8,0.2-57.9-50.3-97.9-54.2c-38.3-3.8-46.4,40.7-92.6,41.4c-37.4,0.6-40.6-31.7-83.6-33.9c-52-2.6-63.7,32-117.5,30.9 c-51.9-1.1-62.5-33.7-97.9-21.8c-24.4,8.2-21.8,24.7-69.7,53.1c-14.3,8.5-24.4,12.9-24.8,21.1C170,710.2,191.9,713,214.3,731.5z"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1"
});

var _ref24 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2"
});

var SvgCircle1 = function SvgCircle1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 967.4 967.4",
    style: {
      enableBackground: "new 0 0 967.4 967.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _ref3, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FDEAE0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_4_",
    style: {
      overflow: "visible"
    }
  })), _ref4, _ref5, _ref6, _ref7)), /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, _ref8, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_7_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FDEAE0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_7_",
    style: {
      overflow: "visible"
    }
  })), _ref9, _ref10, _ref11, _ref12)), /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, _ref13, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FDEAE0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2_",
    style: {
      overflow: "visible"
    }
  })), _ref14, _ref15, _ref16, _ref17)), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, _ref18, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible",
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FDEAE0"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_5_",
    style: {
      overflow: "visible"
    }
  })), _ref19, _ref20, _ref21, _ref22)), _ref23, _ref24);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircle1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Circle1.55bcae09.svg";
export { ForwardRef as ReactComponent };